import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Close } from "icons";
import { useLang } from "hooks";
import CustomModal from "components/CustomModal";
import FixedFooter from "components/FixedFooter";
import { HeadingText } from "components/TextTranslationContainer";

export const SlideInFooter = ({
  children,
  containerStyleProps = {
    className: "dummy-class",
    style: {},
  },
  innerStyleProps = {
    className: "bg-dark-blue-100 p-5",
    style: {},
  },
}) => {
  return (
    <FixedFooter
      containerStyleProps={containerStyleProps}
      innerStyleProps={innerStyleProps}
    >
      {children}
    </FixedFooter>
  );
};

export const SlideInHeader = ({
  title,
  onClose,
  showInLineCloseButton = false,
  showCloseButton = true,
  callBackContent,
  containerStyleProps = {},
}) => {
  return (
    <header
      className={
        "flex justify-between items-center relative p-5 " +
          containerStyleProps?.className ?? ""
      }
      style={containerStyleProps?.style ?? {}}
    >
      {showCloseButton && (
        <button className={`slide-inclose-button group`}>
          <Close
            onClick={onClose}
            className="text-dark-blue-900 group-hover:text-brand-base-primary"
          />
        </button>
      )}
      <HeadingText
        className="flex-1 text-24x font-bold text-dark-blue-900 text-center"
        text={title}
      />
      {callBackContent ? callBackContent : <div className="w-11 h-11" />}
    </header>
  );
};

const SlideInLayout = ({
  open,
  children,
  handleClose = () => {},
  container = {},
  scrollY = 0,
  headerTitle = "",
  bodyclasses = "",
  overlayClasses = "",
  headerCallBackContent = null,
  showHeader = false,
  disableOutsideClick = false,
  showHeaderCloseButton = false,
  hideOutsideCloseButton = false,
  showBar=true,
  ...rest
}) => {
  const modalRef = useRef(null);
  const { isArabic } = useLang();

  const resetBodyStyles = () => {
    document.body.style.position = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollY);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !disableOutsideClick
      ) {
        handleClose();
        resetBodyStyles();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else resetBodyStyles();

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      resetBodyStyles();
    };
  }, [open, disableOutsideClick]);
  return (
    <CustomModal
      open={open}
      setOpen={() => handleClose()}
      bodyclasses={`flex ${bodyclasses}`}
      overlayClasses={`fixed h-screen overflow-y-auto w-screen top-0 bg-black bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-20 border-sc ${overlayClasses}`}
      shouldCloseOnEsc={disableOutsideClick}
      shouldCloseOnOverlayClick={disableOutsideClick}
      {...rest}
    >
      <div
        ref={modalRef}
        className={`fixed bottom-0 bg-white max-460 top-border-rounded transition-transform duration-500 ease-in-out responsive-max-70vh
    ${open ? "translate-y-0" : "translate-y-full"}
    ${isArabic ? "border-sc-l" : "border-sc"}
    ${container?.className || ""}`}
        style={{ ...(container?.style || {}) }}
      >
       {showBar && <div className="absolute w-full top-2 flex justify-center items-center z-20">
          <div className=" h-1 w-11 bg-gray-300 rounded-full" />
        </div>}
        {showHeader ? (
          <SlideInHeader
            onClose={handleClose}
            title={headerTitle}
            callBackContent={headerCallBackContent}
            showCloseButton={showHeaderCloseButton}
          />
        ) : null}
        {!hideOutsideCloseButton && (
          <button
            className={`absolute -top-10 z-20 group cursor-pointer ${
              isArabic ? "left-0" : "right-0"
            }`}
            onClick={handleClose}
          >
            <Close
              className={`text-white group-hover:text-brand-base-primary group-hover:scale-150 transition-all duration-300`}
            />
          </button>
        )}
        {children}
      </div>
    </CustomModal>
  );
};

SlideInLayout.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node,
  currentLang: PropTypes.string,
  selectedItem: PropTypes.any,
  overlayClasses: PropTypes.string,
  bodyclasses: PropTypes.string,
  hideOutsideCloseButton: PropTypes.bool,
  disableOutsideClick: PropTypes.bool,
  container: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
};

export default SlideInLayout;
